import type {
  VisitClientFragmentFragment,
  PackageDepartmentEnum,
} from "@/__generated__/graphql";
import type { ServiceProfileItem } from "../profile/service-profile/lib";
import {
  mapDepartmentToServiceProfileType,
  visibleAttributesValue,
} from "../profile/service-profile/lib";
import { getCapitalizeWord } from "@/lib/utils";

export const mapPackageClientProfileToItem = (
  profile: NonNullable<VisitClientFragmentFragment["packageClientProfile"]>,
  department: PackageDepartmentEnum,
): ServiceProfileItem => {
  const type = mapDepartmentToServiceProfileType(department);
  return {
    id: profile.clientServiceProfile.id,
    name: getCapitalizeWord(profile.name),
    visibleAttributes: visibleAttributesValue(
      { name: profile.name, ...profile.profileAttributes },
      type,
    ),
    isDefault: false,
    type,
  };
};
